import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import MonthlyThroughputChart from "../components/MonthlyThroughputChart";
import DateSelector from "../components/DateSelector";
import MonthlyViewLayout from "../components/MonthlyViewLayout";
import { fetchAllWorkcells } from "../api";
import { useTranslation } from "react-i18next";
import { formatLocalDate } from "../utils/localDateTime";

const MonthlyPlannings = () => {
  const { date, workcell_id } = useParams();
  const navigate = useNavigate();
  const [workcellName, setWorkcellName] = useState("");
  const { t } = useTranslation();

  // Default to today if no date is provided
  const selectedDate = date || formatLocalDate(new Date());

  // Fetch workcell name
  useEffect(() => {
    const getWorkcellName = async () => {
      try {
        const workcells = await fetchAllWorkcells();
        const workcell = workcells.find(w => w.workcell_id === parseInt(workcell_id));
        if (workcell) {
          setWorkcellName(workcell.workcell_name);
        }
      } catch (error) {
        console.error("Error fetching workcell name:", error);
      }
    };

    getWorkcellName();
  }, [workcell_id]);

  // Navigate only if the URL doesn't match
  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/monthly/plannings/${selectedDate}/${workcell_id}`, { replace: true });
    }
  }, [date, selectedDate, workcell_id, navigate]);

  const handleShowTotalMonthlyThroughput = () => {
    navigate(`/chart/monthly/plannings/${selectedDate}`);
  };

  const handleBlockClick = (clickedDate) => {
    // Format date as YYYY-MM-DD if needed
    const targetDate = clickedDate instanceof Date
      ? formatLocalDate(clickedDate)
      : clickedDate
    navigate(`/chart/daily/plannings/${targetDate}/${workcell_id}`)
  }

  return (
    <MonthlyViewLayout date={selectedDate}>
      <DateSelector date={selectedDate} setDate={(newDate) => navigate(`/chart/monthly/plannings/${newDate}/${workcell_id}`)} />
      <Typography variant="h6" gutterBottom>
        {t("monthly.plannings.workcellPage.title", { name: workcellName, id: workcell_id })}
      </Typography>
      <MonthlyThroughputChart
        date={selectedDate}
        workcellId={workcell_id}
        onClick={handleBlockClick}
      />
      <Button variant="contained" onClick={handleShowTotalMonthlyThroughput}>
        {t("monthly.plannings.workcellPage.showTotal")}
      </Button>
    </MonthlyViewLayout>
  );
};

export default MonthlyPlannings;
